import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Chapter, Reveal } from "./Chapter";
import { HEBERGEMENTS } from "../lib/data";

export default function Hebergements() {
  const navigate = useNavigate();
  return (
    <section id="hebergements" className="relative py-28 lg:py-36 px-6 sm:px-10 lg:px-16 bg-cream grain" data-testid="section-hebergements">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div>
            <Chapter num="3" label="Hébergements" />
            <Reveal delay={0.1}>
              <h2 className="mt-6 font-display font-bold text-4xl sm:text-5xl leading-[1.05] tracking-tight text-ink">
                S'endormir au grand air,<br />
                <span className="italic font-medium text-terra">se réveiller en pleine nature.</span>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <p className="max-w-sm text-ink/60 leading-relaxed">
              Mobil-homes tout équipés, emplacements ombragés ou tentes lodges sur pilotis :
              chaque hébergement est pensé pour garantir confort et authenticité.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-8 lg:gap-10">
          {HEBERGEMENTS.map((h, i) => (
            <Reveal key={h.title} delay={0.12 * i}>
              <article
                className={`group cursor-pointer ${h.rotate} transition-transform duration-500 hover:rotate-0 hover:-translate-y-2`}
                data-testid={`hebergement-card-${i}`}
                onClick={() => navigate("/hebergements")}
              >
                <div className="overflow-hidden rounded-[2rem] shadow-xl shadow-ink/15">
                  <img
                    src={h.image}
                    alt={h.title}
                    className="w-full h-80 object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="mt-6 px-2">
                  <span className="font-hand text-2xl text-pine">{h.tag}</span>
                  <h3 className="font-display font-bold text-2xl text-ink mt-1">{h.title}</h3>
                  <p className="text-ink/60 text-sm leading-relaxed mt-2">{h.text}</p>
                  <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-terra group-hover:gap-3 transition-all duration-300">
                    Découvrir <ArrowRight size={15} />
                  </span>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
